import React, { useState } from 'react';
import { Box, Paper } from '@mui/material';
import PurityForm from '../components/purity/PurityForm';
import PurityTable from '../components/purity/PurityTable';

const PurityPage = () => {
  const [selectedPurity, setSelectedPurity] = useState(null);

  const handleEdit = (purity) => {
    setSelectedPurity(purity);
  };

  const handleFormReset = () => {
    setSelectedPurity(null);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        alignItems: 'flex-start',
        width: '100%',
        flexWrap: { xs: 'wrap', md: 'nowrap' }, 
        p: 2,
      }}
    >
      {/* Table - Left Side */}
      <Paper
        elevation={3}
        sx={{
          flex: 2,
          p: 2,
          minWidth: 0,
        }}
      >
        <PurityTable onEdit={handleEdit} />
      </Paper>

      {/* Form - Right Side */}
      <Paper
        elevation={3}
        sx={{
          flex: 1,
          p: 2,
          minWidth: 300,
        }}
      >
        <PurityForm
          selectedPurity={selectedPurity}
          onReset={handleFormReset}
        />
      </Paper>
    </Box>
  );
};

export default PurityPage;
